import alertify from "alertifyjs";
// import bowser from "bowser";
// import * as RoundwareWebFramework from "roundware-web-framework";
import { initRecording } from "./recording";
import { isMobile, isAndroid, isiOS, isChrome, isSafari, browser } from "./responsive";
import { roundware } from "./roundware";
import { CoronaDiariesMapStyle } from "./map-style";
var $ = window.jQuery = require("jquery");
require("gasparesganga-jquery-loading-overlay");

// BROWSER SENSING
console.log(browser);
// First sense mobile/desktop, then sense platform
if (isMobile) {
  console.log("Mobile/tablet device detected");
  // $("#menu-listen").hide();
  if (isiOS && !isSafari) {
    console.log("iOS not using Safari detected");
    const message = "Sorry the browser you’re using isn’t supported yet. Some of our features might not work as intended. We recommend you switch to Safari."
    alertify.alert('<strong>One Square Mile Warning</strong>', message, function() {
      // alertify.message('OK');
    }).set({
      transition: 'zoom',
      closable: false,
      defaultFocusOff: true
    });
  } else if (isAndroid && !isChrome) {
    console.log("Mobile Android browser detected");
    const message = "Sorry the browser you’re using isn’t supported yet. Some of our features might not work as intended. We recommend you switch to Chrome."
    alertify.alert('<strong>One Square Mile Warning</strong>', message, function() {
      // alertify.message('OK');
    }).set({
      transition: 'zoom',
      closable: false,
      defaultFocusOff: true
    });
  } else {
    console.log("Other mobile device detected");
  }
} else {
    console.log("Desktop device detected");
    if (isChrome) {
      console.log("Chrome desktop detected");
    } else {
      console.log("Non-chrome desktop detected");
      const message = "Sorry the browser you’re using isn’t officially supported yet. Some of our features might not work as intended. We recommend you switch to Chrome."
      alertify.alert('<strong>One Square Mile Warning</strong>', message, function(){
      }).set({
        transition:'zoom',
        closable: false,
        defaultFocusOff: true
      });
    }
}

// Safari restrictions on BOTH mobile and desktop
if (isSafari) {
    console.log("Safari browser detected");
    $("#inputmeter").hide();
}

// $("#uiSpeakDisplay").LoadingOverlay("show", {
//     background: "rgba(0, 0, 0, 0.7)",
//     text: "Loading questions...",
//     textColor: "#cccccc",
//     imageColor: "#cccccc",
//     maxSize: "80px"
// });

// local development
// var roundwareServerUrl = "http://localhost:8888/api/2";
// deployment
// var roundwareServerUrl = "https://prod.roundware.com/api/2";
// var roundwareProjectId = 31; // corresponds to a project setup in the Roundware server developer seed script

var streamPlayer, audioSource, pauseButton, playButton, killButton,
  skipButton, replayButton, tagIds, recordButton, setBrowserLocation;
var assetMarkers = [];
var listenMap, speakMap;
var firstplay = false; // ultimately will be set to true initially to handle iOS playback properly
var use_listener_range = false;
var listener_circle_max, listener_circle_min;

window.onbeforeunload = function() { window.scrollTo(0, 0); }

function ready() {
  console.info("Connected to Roundware Server. Ready to play.");
  $("#sessionId").text(roundware._sessionId);
  // $("#uiSpeakDisplay").LoadingOverlay("hide", true);

  // playButton.prop("disabled",false);
  // playButton.click(play);
  // pauseButton.click(pause);
  // killButton.click(kill);
  // replayButton.click(replay);
  // skipButton.click(skip);
  // updateButton.click(update);

  // displayListenTags();
  displaySpeakTags();
  // setupListenMap();
  setupSpeakMap();
}


function displaySpeakTags() {
  console.log(roundware.uiConfig.speak);
  let speakUi = roundware.uiConfig.speak;
  $.each(speakUi, function(index, element) {
    console.log(index + ": " + element.header_display_text);
    // let str = "<h4>" + (index + 1) + " - ";
    let groupShortName = element.group_short_name;
    let order = index;
    let str = "";
    // if (index == 0) {
    //   str = `<h4 category=${groupShortName}>`;
    //   str += `${element.header_display_text}</h4>`;
    // } else {
    //   str = `<h4 style="display:none" category=${groupShortName}>`;
    //   str += `${element.header_display_text}</h4>`;
    // }
    str += "<form>";
    $.each(element.display_items, function(index, element) {
      let checked = "";
      if (element.default_state) {
        checked = "checked";
      }
      str += `<div class="col-6 col-12-small" `;
      if (order != 0) {
        // if (element.parent_id != null && order != 0) {
        console.log(`order = ${order}`);
        str += `style="display:none">`;
      } else {
        str += `>`;
      }
      str += `<input type="radio" class="uiitem" `;
      str += `name=${groupShortName} `;
      str += `uigroupindex=${order} `;
      str += `id=${element.id} `;
      str += `tag_id=${element.tag_id} `;
      str += `parent_id=${element.parent_id} `;
      str += `${checked}>`;
      str += `<label for="${element.id}">${element.tag_display_text}</label>`;
      str += `</div>`;
    });
    str += "</form>";
    $('#uiSpeakDisplay').append(str);
  });

  // setup tag change listeners
  $('#uiSpeakDisplay input:radio').change(
    function() {
      let speakUIItemIds = ["n"];
      let numOfCategories = roundware.uiConfig.speak.length;
      console.log(`number of tag categories = ${numOfCategories}`);
      // console.log(`number of tag categories: ${numOfCategories}`);
      // after question selected, init recording
      // TODO: really should be after LAST one selected
      if ($(this).attr("name") == "Question") {
        console.log("final tag category has been selected");
        $("#recordInstructions").hide();
        let legalMessage = roundware._project.legalAgreement;
        console.log("legal message: " + legalMessage);
        alertify.confirm('<strong>Legal Agreement</strong>', legalMessage,
          function() {
            // alertify.success('Agree');
            initRecording(roundware);
            startRecordButton.disabled = false;
            $([document.documentElement, document.body]).animate({
              // $("#main").animate({
              scrollTop: $("#location").offset().top - 75
              // scrollTop: "200px"
            }, 500);
          },
          function() {
            // alertify.error('Cancel');
          }).set({
            transition: 'zoom',
            closable: false,
            defaultFocusOff: true
          });
      }
      $("#uiSpeakDisplay input:checked").each(function() {
        speakUIItemIds.push($(this).attr('id'));
      });
      // update();
      console.log(`selected speak uiitem_ids: ${speakUIItemIds}`);
      let currentUIGroupIndex = parseInt($(this).attr('uigroupindex'));
      // for all uiitem/checkbox in FUTURE uigroups, show if parent_id=this.id
      $('.uiitem').each(function(index, element) {
        console.log(`${$(this).attr("uigroupindex")} = (${currentUIGroupIndex} + 1)`);
        // show items in next uigroup with selected uiitem_id or "null" as their parent_id
        if (parseInt($(this).attr("uigroupindex")) == currentUIGroupIndex + 1) {
          if ($.inArray($(this).attr("parent_id"), speakUIItemIds) !== -1 ||
            $(this).attr("parent_id") == "null") {
            let selectedCategory = $(this).attr("name");
            $(this).parent().css("display", "inherit");
            // change display for associated <h2> as well
            $("#uiSpeakDisplay h4").each(function() {
              if ($(this).attr("category") == selectedCategory) {
                $(this).css("display", "inherit");
                $([document.documentElement, document.body]).animate({
                  scrollTop: $(this).offset().top - 100
                }, 500);
              }
            });
          } else {
            $(this).parent().css("display", "none");
          }
        }
      });
    });
}


// Generally we throw user-friendly messages and log a more technical message
function handleError(userErrMsg) {
  console.error("There was a Roundware Error: " + userErrMsg);
}

$(function startApp() {
  // roundware = new RoundwareWebFramework.Roundware(window, {
  //     serverUrl: roundwareServerUrl,
  //     projectId: roundwareProjectId,
  //     geoListenEnabled: false
  //     // apply any speaker filters here
  //     // speakerFilters: {"activeyn": true},
  //     // apply any asset filters here
  //     // assetFilters: {"submitted": true,
  //     //                "media_type": "audio"}
  // });

  // Listen elements
  // streamPlayer    = $("#streamplayer");
  // audioSource     = $("#audiosource");
  // pauseButton     = $("#pause");
  // playButton      = $("#play");
  // killButton      = $("#kill");
  // replayButton    = $("#replay");
  // skipButton      = $("#skip");
  // listenLatitude  = $("#listenLatitude");
  // listenLongitude = $("#listenLongitude");
  // updateButton    = $("#update");

  // Speak elements
  // setBrowserLocation = $("#setBrowserLocation");
  // const speakLatitude = $("#speakLatitude");
  // const speakLongitude = $("#speakLongitude");
  // recordButton       = $("#record");
  // startRecordButton  = $("#startRecordButton");

  roundware.connect().
    then(ready);

  // document.getElementById("initRecorder").addEventListener( "click", function(){
  //   initRecording();
  //   // startRecordButton.prop("disabled",false);
  //   startRecordButton.disabled = false;
  //   initRecorder.disabled = true;
  // });

});

// Google Maps

function setupSpeakMap() {
  // TODO: change to location sensed by browser
  var initialLocation = {
    lat: roundware._project.location.latitude,
    lng: roundware._project.location.longitude
  };
  if (!navigator.geolocation) {
    console.log("no geolocation available");
  }
  else {
    console.log("geolocation available");

        navigator.geolocation.getCurrentPosition(function(position) {
            initialLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            console.log(`initial browser determined position = ${initialLocation}`);
            console.log(initialLocation);
            speakMap.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
            var newPosition = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
            contributor.setPosition(newPosition);
            document.getElementById("speakLatitude").value = contributor.getPosition().lat();
            document.getElementById("speakLongitude").value = contributor.getPosition().lng();
            speakMap.setZoom(15);
            // do_something(position.coords.latitude, position.coords.longitude);
        });

        // var watchID = navigator.geolocation.watchPosition(function(position) {
        //   console.log("map watcher invoked!");
        //     speakMap.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
        //     var newPosition = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        //     contributor.setPosition(newPosition);
        //     document.getElementById("speakLatitude").value = contributor.getPosition().lat();
        //     document.getElementById("speakLongitude").value = contributor.getPosition().lng();
        // });
    }

    speakMap = new google.maps.Map(document.getElementById('speakMap'), {
        zoom: 2,
        center: initialLocation,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        // mapTypeId: 'hybrid',
        styles: CoronaDiariesMapStyle
    });
    var contributor = new google.maps.Marker({
        position: initialLocation,
        map: speakMap,
        draggable: true
    });

    // var watchID = navigator.geolocation.watchPosition(function(position) {
    //   speakMap.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
    //   var newPosition = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
    //   contributor.setPosition(newPosition);
    //   document.getElementById("speakLatitude").value = contributor.getPosition().lat();
    //   document.getElementById("speakLongitude").value = contributor.getPosition().lng();
    // });
  // }

  google.maps.event.addListener(contributor, "dragend", function(event) {
    document.getElementById("speakLatitude").value = contributor.getPosition().lat();
    document.getElementById("speakLongitude").value = contributor.getPosition().lng();
    speakMap.setCenter(contributor.getPosition());
  });

  // setup place autocomplete
  var input = document.getElementById('pac-input');
  speakMap.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
  var autocomplete = new google.maps.places.Autocomplete(input);
  autocomplete.bindTo('bounds', speakMap);

  autocomplete.addListener('place_changed', function() {
    // marker = new google.maps.Marker({
    //     map: speakMap,
    //     anchorPoint: new google.maps.Point(0, -29),
    //     draggable: true
    // });
    contributor.setVisible(false);
    var place = autocomplete.getPlace();
    if (!place.geometry) {
      // User entered the name of a Place that was not suggested and
      // pressed the Enter key, or the Place Details request failed.
      window.alert("No details available for input: '" + place.name + "'");
      return;
    }
    // If the place has a geometry, then present it on a map.
    if (place.geometry.viewport) {
      speakMap.fitBounds(place.geometry.viewport);
    } else {
      speakMap.setCenter(place.geometry.location);
      speakMap.setZoom(10);
    }
    // contributor.setIcon({
    //     url: place.icon,
    //     size: new google.maps.Size(71, 71),
    //     origin: new google.maps.Point(0, 0),
    //     anchor: new google.maps.Point(17, 34),
    //     scaledSize: new google.maps.Size(35, 35)
    // });
    contributor.setPosition(place.geometry.location);
    contributor.setVisible(true);

    document.getElementById("speakLatitude").value = contributor.getPosition().lat();
    document.getElementById("speakLongitude").value = contributor.getPosition().lng();

    // rww.setMarker(marker);
    // $('input.tag').trigger('change');
  });

  // element.addEventListener("click", function(){ alert("Hello World!"); });
  // document.getElementById("setBrowserLocation").addEventListener( "click", function(){
  //   console.log("setting browser location in map");
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(function(position) {
  //       console.log("current browser position determined");
  //       speakMap.setCenter({lat:position.coords.latitude, lng:position.coords.longitude});
  //       var newPosition = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
  //       contributor.setPosition(newPosition);
  //       document.getElementById("speakLatitude").value = contributor.getPosition().lat();
  //       document.getElementById("speakLongitude").value = contributor.getPosition().lng();
  //     });
  //   } else {
  //     console.log("no location available");
  //   }
  // });
}
